import { render, staticRenderFns } from "./dash_sales.vue?vue&type=template&id=1633621a&scoped=true"
import script from "./dash_sales.vue?vue&type=script&lang=js"
export * from "./dash_sales.vue?vue&type=script&lang=js"
import style0 from "./dash_sales.vue?vue&type=style&index=0&id=1633621a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633621a",
  null
  
)

export default component.exports